<template>
  <div class="silkDiv">
    <img v-if="runner.tabNo" tile color="white" alt="silk" @error="setAltImage" :src="silkImg" style="height:45px;width:45px;">
  </div>
</template>

<script>
export default {
  data: () => ({
    defaultSilk: '/assets/default_silk.png'
  }),
  props: {
    runner: Object,
    race: Object
  },
  methods: {
    setAltImage (event) {
      event.target.src = '/assets/default_silk.png'
    },
  },
  computed: {
    silkImg () {
      if (this.race?.meeting?.externalIDs) {
      const url = 'https://d1o4owrv8e0i8g.cloudfront.net/' +
        this.race?.meeting?.externalIDs[0]?.id +
        '_' +
        this.race.number +
        '_' +
        this.runner.tabNo +
        '_' +
        '64x64.png'
        return url
      } return this.defaultSilk
    },
  }

}
</script>

<style scoped>
  .silkDiv {
    height: 45px;
    width: 45px;
  }
</style>